import {useId} from 'react';

// Shared visual language with Premium's gift offer, using Bite's existing color tokens.
export function BiteOfferGift() {
  const id = useId();
  return <span className="bite-offer-gift-art" aria-hidden="true">
    <span className="bite-offer-gift-aura" />
    <svg className="bite-offer-gift-vector" viewBox="0 0 120 120" fill="none" focusable="false">
      <defs>
        <linearGradient id={`${id}-box`} x1="24" y1="52" x2="86" y2="107" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--bite-red-hot)" />
          <stop offset=".5" stopColor="var(--bite-red)" />
          <stop offset="1" stopColor="var(--bite-red-blood)" />
        </linearGradient>
        <linearGradient id={`${id}-gold`} x1="34" y1="32" x2="72" y2="95" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--bite-research-white)" />
          <stop offset=".28" stopColor="var(--bite-credit-light)" />
          <stop offset=".58" stopColor="var(--bite-credit-gold)" />
          <stop offset=".82" stopColor="var(--bite-credit-light)" />
          <stop offset="1" stopColor="var(--bite-credit-gold)" />
        </linearGradient>
        <linearGradient id={`${id}-lid`} x1="20" y1="43" x2="88" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--bite-credit-light)" />
          <stop offset=".35" stopColor="var(--bite-red-hot)" />
          <stop offset="1" stopColor="var(--bite-red)" />
        </linearGradient>
        <clipPath id={`${id}-front`}><rect x="25" y="56" width="60" height="49" rx="7" /></clipPath>
      </defs>
      <path d="M84 56 101 46V92Q101 97 96 100L78 108 84 98Z" fill="var(--bite-red-blood)" />
      <rect x="25" y="56" width="60" height="49" rx="7" fill={`url(#${id}-box)`} />
      <g clipPath={`url(#${id}-front)`}>
        <path d="M44 55H66V106H44Z" fill={`url(#${id}-gold)`} />
        <path d="m19 67 52-22h18l-70 36Z" fill="var(--bite-research-white)" opacity=".13" />
      </g>
      <text x="55" y="91" textAnchor="middle" className="bite-offer-gift-question">?</text>
      <path className="bite-offer-gift-seam" d="M24 58H85L102 48" stroke="var(--bite-credit-light)" strokeWidth="3" strokeLinecap="round" />
      <g className="bite-offer-gift-lid">
        <path d="m18 45 20-12h64q5 0 5 4L85 49Z" fill={`url(#${id}-lid)`} />
        <path d="m85 47 22-12v14L85 63Z" fill="var(--bite-red-blood)" />
        <rect x="18" y="45" width="68" height="16" rx="4" fill={`url(#${id}-lid)`} />
        <path d="M43 45 63 33h21L65 45v16H43Z" fill={`url(#${id}-gold)`} />
        <path fillRule="evenodd" d="M59 37C36 39 22 22 31 15c10-8 29 8 30 20L59 37ZM51 31C47 23 37 18 36 22c-1 4 7 8 15 9Z" fill={`url(#${id}-gold)`} />
        <path fillRule="evenodd" d="M59 37C59 17 78 10 85 18c8 10-7 21-26 19ZM67 30c10-1 15-7 12-9-3-2-9 2-12 9Z" fill={`url(#${id}-gold)`} />
        <rect x="53" y="29" width="15" height="13" rx="5" fill={`url(#${id}-gold)`} />
        <path d="M24 48H40" stroke="var(--bite-research-white)" strokeOpacity=".65" strokeWidth="2" strokeLinecap="round" />
      </g>
      <path className="bite-offer-gift-star bite-offer-gift-star-one" d="m103 12 2.5 7.5L113 22l-7.5 2.5L103 32l-2.5-7.5L93 22l7.5-2.5Z" />
      <path className="bite-offer-gift-star bite-offer-gift-star-two" d="m13 66 2 6 6 2-6 2-2 6-2-6-6-2 6-2Z" />
      <path className="bite-offer-gift-star bite-offer-gift-star-three" d="m105 93 1.5 4.5L111 99l-4.5 1.5L105 105l-1.5-4.5L99 99l4.5-1.5Z" />
    </svg>
  </span>;
}
